export const ANNOTATION_TYPE_INFO = 'info';
export const ANNOTATION_TYPE_SUCCESS = 'success';
export const ANNOTATION_TYPE_ERROR = 'error';

export const ANNOTATION_TYPES = [
    ANNOTATION_TYPE_INFO,
    ANNOTATION_TYPE_SUCCESS,
    ANNOTATION_TYPE_ERROR,
];
